<div class="st-add-view-to-navigation-header">
    <mat-icon class="material-icons-outlined">bookmark_add</mat-icon>
    <div class="st-add-view-to-navigation-header-title">Add view to navigation</div>
</div>
<div class="st-add-view-to-navigation-body">
    <mat-form-field
        class="st-add-view-to-navigation-body-form-field"
        style="width: 100%">
        <mat-label>Group</mat-label>
        <mat-select
            [(value)]="selectedGroup"
            (selectionChange)="onSelectionChange()">
            <mat-option
                *ngFor="let group of groups$ | ngrxPush"
                [value]="group">
                {{ group.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-selection-list
        [multiple]="false"
        [(ngModel)]="selectedSection">
        <mat-list-option
            *ngFor="let section of sections"
            [value]="section">
            <div matListItemTitle>{{ section.label }}</div>
        </mat-list-option>
    </mat-selection-list>
</div>
<div class="st-add-view-to-navigation-footer">
    <button
        mat-button
        class="st-add-view-to-navigation-button-no"
        (click)="onCancelClick()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-button
        class="st-add-view-to-navigation-button-yes"
        cdkInitialFocus
        [disabled]="isConfirmDisabled"
        (click)="onConfirmClick()">
        {{ languageSettings.PSTWebConfirmButtonLabel }}
    </button>
</div>
